import * as THREE from "three";

export default class BillboardHotspot extends THREE.Group {
  constructor(config) {
    super();

    this.config = config;

    const map = new THREE.TextureLoader().load(
      `${window.location.origin}/tour/assets/billboard.png`,
    );
    const mat = new THREE.SpriteMaterial({ map, color: 0xffffff });
    const s = new THREE.Sprite(mat);
    s.position.x = config.x;
    s.position.y = config.y;
    s.position.z = config.z;
    s.scale.x = 0.15;
    s.scale.y = 0.15;
    s.scale.z = 0.15;
    this.add(s);

    // s.renderOrder = -1;
    this.object = s;
  }

  getOpacity() {
    return this.material.opacity;
  }

  setOpacity(opacity) {
    this.material.opacity = opacity;

    if (opacity >= 1) {
      this.material.transparent = false;
    }
  }

  getObject() {
    return this.object;
  }

  getImage() {
    return this.config.image;
  }

  setScale(scale) {
    this.object.scale.setScalar(scale);
  }
}
